/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ApprovalReportProductionOrderPhaseType {
  Setup = 'Setup',
  Run = 'Run',
  Downtime = 'Downtime',
  Consumption = 'Consumption'
}
